import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { CustomFieldPlainTextTableCellInput } from "~/components/TableView/TableRow/CustomFieldTableCell/CustomFieldPlainTextTableCellInput";
import { useUpdatePublicItemsCustomFieldValue } from "~/utils/CustomFields/useUpdatePublicItemsCustomFieldValue";
export const PublicBoardCustomFieldPlainTextInputTableCell = /*#__PURE__*/ memo((param)=>{
    let { field, trackingLocation, boardId, closeEditor } = param;
    const { updatePublicItemsCustomFieldValue } = useUpdatePublicItemsCustomFieldValue();
    const updateCustomFieldValue = useCallback(async (value)=>{
        await updatePublicItemsCustomFieldValue({
            boardIds: [
                boardId
            ],
            baseCustomField: field,
            nextPlainTextValue: value,
            trackingLocation
        });
    }, [
        boardId,
        updatePublicItemsCustomFieldValue,
        field,
        trackingLocation
    ]);
    return /*#__PURE__*/ _jsx(CustomFieldPlainTextTableCellInput, {
        onBlur: closeEditor,
        defaultValue: field.plainTextValue,
        onSubmit: updateCustomFieldValue,
        fieldName: field.name
    });
});
PublicBoardCustomFieldPlainTextInputTableCell.displayName = "PublicBoardCustomFieldPlainTextInputTableCell";
